import type { CauseSelection } from "@/interfaces/charity";

/** Step 4's cause state: what is selected, and whether anyone (client or saved draft) decided it. */
export interface CauseChoice {
  causes: readonly CauseSelection[];
  decided: boolean;
}

export const UNDECIDED_CAUSES: CauseChoice = Object.freeze({ causes: [], decided: false });

/** From a loaded draft: a non-empty saved list is a decision; empty or undefined is not. */
export function hydrateCauseChoice(saved: CauseSelection[] | undefined): CauseChoice {
  if (!saved || saved.length === 0) return UNDECIDED_CAUSES;
  return { causes: saved, decided: true };
}

/** The client's own pick — a decision even when empty. */
export function chooseCauses(causes: CauseSelection[]): CauseChoice {
  return { causes, decided: true };
}

/** Fills an undecided choice with the platform default. A decided choice, or an empty/undefined
 *  default, returns the SAME choice reference (so a setState updater bails out). */
export function adoptDefaultCauses(
  choice: CauseChoice,
  platformDefault: readonly CauseSelection[] | undefined,
): CauseChoice {
  if (choice.decided) return choice;
  if (!platformDefault || platformDefault.length === 0) return choice;
  return { causes: platformDefault, decided: true };
}
